import { useTheme } from "hooks/ThemeContext";
import { ColorType, createChart } from "lightweight-charts";
import { useEffect, useRef } from "react";
import { formatTimestamp } from "utils";

const Chart = ({ dataSets, dataSets2 }) => {
  const { theme } = useTheme();
  const chartContainerRef = useRef(null);
  const chartRef = useRef(null);
  const areaSeriesRef = useRef(null);
  const areaSeries2Ref = useRef(null);
  const tooltipRef = useRef(null);
  const backgroundColor = "transparent";
  const lineColor = theme === "dark" ? "white" : "black";
  const textColor = theme === "dark" ? "black" : "white";
  const lineColor2 = "#585A5A";

  useEffect(() => {
    // Create the chart
    if (!chartRef.current) {
      chartRef.current = createChart(chartContainerRef.current, {
        // width: chartContainerRef.current.clientWidth,
        height: 300,

        layout: {
          background: { type: ColorType.Solid, color: backgroundColor },
          textColor: textColor,
        },

        handleScroll: {
          mouseWheel: false,
        },
        handleScale: {
          mouseWheel: false,
        },
        grid: {
          vertLines: { visible: false }, // Hide vertical grid lines
          horzLines: { visible: false }, // Hide horizontal grid lines
        },
        timeScale: {
          borderVisible: false,
          secondsVisible: true,
          timeVisible: true,
        },

        rightPriceScale: {
          borderVisible: false,
        },
      });

      areaSeriesRef.current = chartRef.current.addLineSeries({
        color: lineColor,
        lineWidth: 1,
        lastPriceAnimation: "OnDataUpdate",
      });

      areaSeries2Ref.current = chartRef.current.addLineSeries({
        color: lineColor2,
        lineWidth: 1,
        lastPriceAnimation: "OnDataUpdate",
      });

      areaSeriesRef.current.setData(dataSets);
      areaSeries2Ref.current.setData(dataSets2);

      const toolTipWidth = 250;
      const toolTipHeight = 100;
      const tooltip = tooltipRef.current;
      const toolTipMargin = 15;

      // Create and style the tooltip html element
      tooltip.style = `width: ${toolTipWidth}px; height: 100px; position: absolute; display: none; padding: 15px; padding-top:8px ; padding-bottom:8px  box-sizing: border-box; font-size: 12px; text-align: left; z-index: 1000; top: 12px; left: 12px; pointer-events: none; border-radius:10px; border-bottom: none; box-shadow: 0 2px 5px 0 rgba(33, 35, 36, 0.45);font-family: N_Roman; -webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale;`;
      tooltip.style.background = `rgba(${"31, 31, 31"}, 1`;
      tooltip.style.color = "var(--white)";
      tooltip.style.borderColor = "rgba( 239, 83, 80, 1)";
      chartRef.current.subscribeCrosshairMove((param) => {
        if (
          param.point === undefined ||
          !param.time ||
          param.point.x < 0 ||
          param.point.x > chartContainerRef.current.clientWidth ||
          param.point.y < 0 ||
          param.point.y > chartContainerRef.current.clientHeight
        ) {
          tooltip.style.display = "none";
          return;
        }

        const price = param.seriesData
          .get(areaSeries2Ref.current)
          ?.value.toFixed(2);
        const equity = param.seriesData
          .get(areaSeriesRef.current)
          ?.value.toFixed(2);

        const date = param.time;
        const pl = parseFloat(equity) - parseFloat(price);

        if (price && equity) {
          tooltip.style.display = "block";
          tooltip.innerHTML = `<div style="display: flex; width: 100%; justify-content: space-between; flex-direction: row " >
      
          <div style="color: ${"rgba( 255, 255, 255, 0.5)"}">${formatTimestamp(
            date
          )}</div>
              <div style="color: ${
                pl > 0
                  ? "var(--green)"
                  : !pl
                  ? "var(--white-opacity)"
                  : "var(--red)"
              }">
            ${
              parseFloat(pl)
                ? parseFloat(pl).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                  })
                : "0.00"
            }
            
            </div>
          </div>
          </div><div style=" display: flex; width: 100%;  flex-direction: row; gap:2.5rem ; margin-top: 1rem">
                      <div className="flex flex-col gap-1">
                        <div style="color: var(--white-opacity)">Balance</div>
                        <div  style="color: var(--white)">
                          ${parseFloat(price).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                          })}
                        </div>
                      </div>
                      <Separator
                        orientation="vertical"
                        className="bg-white-opacity w-[0.1rem] rounded-md h-12 opacity-50"
                      />
                      <div className="flex flex-col gap-1">
                        <div style="color: var(--white-opacity)">Equity</div>
                        <div style="color: var(--white)">
                          ${parseFloat(equity).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                          })}
                        </div>
                      </div>
                    </div>`;

          const y = param.point.y;
          let left = param.point.x + toolTipMargin;
          if (left > chartRef.current.clientWidth - toolTipWidth) {
            left = param.point.x - toolTipMargin - toolTipWidth;
          }

          let top = y + toolTipMargin;
          if (top > chartRef.current.clientHeight - toolTipHeight) {
            top = y - toolTipHeight - toolTipMargin;
          }
          if (param.point.x + 250 > chartContainerRef.current.clientWidth) {
            tooltip.style.left = left - 250 + "px";
          } else {
            tooltip.style.left = left + "px";
          }
          tooltip.style.top = top + "px";
        }
      });
    }

    // Set data for the selected series

    return () => {
      if (chartRef.current) {
        chartRef.current.remove();
        chartRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    if (chartRef.current) {
      chartRef.current.timeScale().fitContent();

      areaSeriesRef.current.setData(dataSets);
      areaSeries2Ref.current.setData(dataSets2);
    }
  }, [dataSets, dataSets2]);
  return (
    <div className=" chart_cont">
      <div
        ref={chartContainerRef}
        style={{ position: "relative", width: "100%", height: "300px" }}
      >
        <div ref={tooltipRef} className="custom-tooltip absolute" />
      </div>
    </div>
  );
};

export default Chart;
